<template>
  <div></div>
</template>

<script>
  import creditApis from '@/api/creadit'
  import { Dialog, Toast } from 'vant'

  // CA认证结果状态
const STATUS_POLLING = 0; // 人脸认证中，需轮询
const STATUS_FAILED = 1; // 认证失败
const STATUS_REVIEWING = 2; // 人工审核中
const STATUS_SUCCESS = 4; // 制证成功
const STATUS_MAKE_FAILED = 5; // 制证失败
const STATUS_BIND_IDCARD = 6; // 已绑定身份证号码

  export default {
    name: 'faceVerifying',
    data() {
      return {
        query: {},
        creditMsg: undefined,
        transactionId: undefined
      }
    },
    created() {
      this.creditMsg = this.$store.state.creditMsg
      this.getQuery()
      this.updateH5FaceResult()
    },
    computed: {
      // creditMsg() {
      //   return this.$store.state.creditMsg
      // },
    },

    methods: {
      getQuery() {
        const { query } = this.$route
        this.transactionId = query.transactionId
        console.log("🚀 ~ query:", this.transactionId)
        this.query = query
      },
      async updateH5FaceResult() {
        try {
          // const { userId } = this.creditMsg
          // if (!userId) return
          this.$toast.loading({
            message: '处理中',
            duration: 20000,
          })
          const model = {
            ...this.query,
            // userIdE: userId,
          }
          const res = await creditApis.queryCaVerify({
            id: this.transactionId
          })
          if (res.status === STATUS_SUCCESS) {
            this.$router.replace({
              name: 'authenticationSuccess',
            })
          } else {
            Dialog.alert({
              title: '',
              message: res.msg,
              confirmButtonText: '去认证',
            }).then(() => {
              this.$router.replace({
                name: 'authenticationError',
                query: {
                  type: 'face',
                },
              })
            })
          }

        } catch (error) {
          console.error(error)
          this.$router.replace({
            name: 'authenticationError',
            query: {
              type: 'face',
            },
          })
        } finally {
          this.$toast.clear()
        }
      },
    },
  }
</script>

<style lang="less" scoped></style>
